import { BACKEND_DATA_SOURCE, selectDataSource } from './dataSource'
import { createMinecardsBackendClient } from './minecardsBackendClient'

export const backendForFirebaseUser = (
    user,
    environment = process.env,
    fetchImpl = window.fetch.bind(window)
) => {
    if (selectDataSource(user?.uid, environment) !== BACKEND_DATA_SOURCE) {
        return null
    }

    return createMinecardsBackendClient({
        baseUrl: environment.REACT_APP_BACKEND_BASE_URL || '',
        fetchImpl,
        getToken: async () => {
            if (!user || typeof user.getIdToken !== 'function') {
                return null
            }
            return user.getIdToken()
        },
    })
}
